/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const publicCefrChallengeSampleSchema = z.object({
  id: z.number(),
  slug: z.string(),
  title: z.string(),
  cefrLevel: z.string(),
  definition: z.string(),
  partOfSpeech: z.string(),
});
